export function isValidEmail(s) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s || '').trim())
}

export function isValidWebsiteOptional(s) {
  const v = String(s || '').trim()
  if (!v) return true
  const withScheme = /^https?:\/\//i.test(v) ? v : `https://${v}`
  return /^https?:\/\/([\w-]+\.)+[\w-]+(\/\S*)?$/i.test(withScheme)
}

export function getStep3FieldErrors({
  bizName,
  contactName,
  bizEmail,
  bizPhone,
  bizWeb,
}) {
  const err = {}
  if (!String(bizName || '').trim()) err.bizName = true
  if (!String(contactName || '').trim()) err.contactName = true
  if (!isValidEmail(bizEmail)) err.bizEmail = true
  const digits = String(bizPhone || '').replace(/\D/g, '')
  if (digits.length !== 10) err.bizPhone = true
  if (!isValidWebsiteOptional(bizWeb)) err.bizWeb = true
  return err
}
